
import PropTypes from 'prop-types'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography
} from '@mui/material'

import Icon from '@mui/icons-material/ErrorOutline'
import { Page } from 'frame/components'
import { getAppConfig } from 'app-config'
import { themeV5 } from 'theme/v5'

const FleetNotFound = ({ title }) => {

  const config = getAppConfig()

  const onEmailSupport = () => {
    window.open(config.email.help)
    // window.location = config.email.help
  }

  return (
    <Page
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 'calc(100vh - 90px)',
      }}
      title={title}>
      <Card>
        <CardContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            position: 'relative',
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: 90,
              height: 90,
              position: 'absolute',
              top: -24,
              left: -80,
            }}>
            <Icon
              sx={{
                color: themeV5.palette.text.primary,
                fontSize: 60,
              }}/>
          </div>
          <Typography
            gutterBottom
            variant="h1">
            No fleets available
          </Typography>
          <Typography variant="body1">
            It looks like you&apos;re not assigned to any fleets.
            <br />
            Please contact your administrator or Toyota Fleet Management New Zealand for support.
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            aria-label="email support"
            color="primary"
            variant="contained"
            onClick={onEmailSupport}>
            Email Support
          </Button>
        </CardActions>
      </Card>
    </Page>
  )
}

FleetNotFound.propTypes = {
  title: PropTypes.string.isRequired,
}

export default FleetNotFound
